export default __webpack_public_path__ + "static/media/boots_of_vengeful_zeal.7c7b7d7b.jpg";